export type NewsPublisherId = 'bbc' | 'bbcmundo' | 'guardian' | 'elpais' | 'hackernews';

export const NEWS_PUBLISHER_IDS: readonly NewsPublisherId[] = [
  'bbc',
  'bbcmundo',
  'guardian',
  'elpais',
  'hackernews',
] as const;

export type NewsPublisherFeed = {
  id: NewsPublisherId;
  label: string;
  /** Path under /api/news-rss/{id} */
  proxyPath: string;
  homepage: string;
};

export const NEWS_PUBLISHERS: Record<NewsPublisherId, NewsPublisherFeed> = {
  bbc: {
    id: 'bbc',
    label: 'BBC News',
    proxyPath: '/api/news-rss/bbc',
    homepage: 'https://www.bbc.com/news',
  },
  bbcmundo: {
    id: 'bbcmundo',
    label: 'BBC Mundo',
    proxyPath: '/api/news-rss/bbcmundo',
    homepage: 'https://www.bbc.com/mundo',
  },
  guardian: {
    id: 'guardian',
    label: 'The Guardian',
    proxyPath: '/api/news-rss/guardian',
    homepage: 'https://www.theguardian.com/international',
  },
  elpais: {
    id: 'elpais',
    label: 'El País',
    proxyPath: '/api/news-rss/elpais',
    homepage: 'https://elpais.com',
  },
  hackernews: {
    id: 'hackernews',
    label: 'Hacker News',
    proxyPath: '/api/news-rss/hackernews',
    homepage: 'https://news.ycombinator.com',
  },
};

/** Allowed upstream URLs for the news-rss Netlify function (slug → URL). */
export const NEWS_PUBLISHER_UPSTREAM: Record<NewsPublisherId, string> = {
  bbc: 'https://feeds.bbci.co.uk/news/rss.xml',
  bbcmundo: 'https://feeds.bbci.co.uk/mundo/rss.xml',
  guardian: 'https://www.theguardian.com/world/rss',
  elpais: 'https://feeds.elpais.com/mrss-s/pages/ep/site/elpais.com/portada',
  hackernews: 'https://hnrss.org/frontpage',
};
